

const icons = {
  url: 'link-external-01',
  api: 'container',
  genrate: 'stars-02',
  internal: 'alert-circle'
}

const stroke_width = {
  'link-external-01': 1,
  'container': 0.8,
  'stars-02': 1,
}

const size = {
  'link-external-01': 1.7,
  'container': 1.7,
  'stars-02': 1.8,
}

const color = {
  'alert-circle': 'var(--error-700)'
}

export default {
  props: {
    type: {type: String, required: true},
  },
  computed: {
    icon() {
      return icons[this.type] || 'file-04'
    },
    stroke_width(){
      return stroke_width[this.icon] || 1.4
    },
    icon_size(){
      return (size[this.icon] || 1.6) + 'rem'
    },
    color(){
      return color[this.icon] || 'var(--gray-600)'
    }
  }
}
